(function (angular) {
  "use strict";

  angular.module('myApp').component('menucategory', {
    templateUrl: '/menucategory/views/List.tpl.html',
    controller: [
      '$scope', 'aimList',
      function ($scope, aimList) {

        $scope.list = new aimList();
        $scope.list.url = 'api/admin/menucategory/';
        $scope.list.module = 'menu';
        $scope.list.actions = undefined;
        $scope.list.showPaging = true;
        $scope.list.load();
      }
    ]
  });

}(window.angular));
